module.exports = __webpack_public_path__ + "img/ecology-action@3x.3536b6fa.webp";